module.exports = __webpack_public_path__ + "static/img/14000641.5feda3c2.png";